import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  sort: "Default",
  type: "",
};

const jobsFilterSlice = createSlice({
  name: "jobsFilter",
  initialState,
  reducers: {
    searched: (state, action) => {
      state.search = action.payload;
    },
    sorted: (state, action) => {
      state.sort = action.payload;
    },
    typeChanged: (state, action) => {
      state.type = action.payload;
    },
  },
});

export default jobsFilterSlice.reducer;
export const { searched, sorted, typeChanged } = jobsFilterSlice.actions;
